var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.00226e-06 8.54839L18.5189 8.54839L11.9351 2L13.9135 2.43272e-06L24 10.0323L13.9135 20L11.9351 18L18.5514 11.4516L1.49465e-06 11.4516L2.00226e-06 8.54839Z","fill":"black"}));
}

ArrowRight.defaultProps = {"width":"24","height":"20","viewBox":"0 0 24 20","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
